<h2 mat-dialog-title>Export Report</h2>

<mat-dialog-content>
	<div class="container">
		<!-- Export Format Selection -->
		<div class="export-option-group">
			<label class="export-label">Export Format</label>
			<mat-button-toggle-group
				[value]="exportFormat()"
				(valueChange)="onFormatChange($event)"
				class="export-toggle-group"
			>
				@for (format of exportFormats; track format) {
					<mat-button-toggle [value]="format">{{ format }}</mat-button-toggle>
				}
			</mat-button-toggle-group>
		</div>

		<!-- Data Scope Selection -->
		<div class="export-option-group">
			<label class="export-label">Data Scope</label>
			<mat-button-toggle-group
				[value]="dataScope()"
				(valueChange)="onScopeChange($event)"
				class="export-toggle-group"
			>
				<mat-button-toggle value="filtered"
					>Currently Filtered Data</mat-button-toggle
				>
				<mat-button-toggle value="all">All Data</mat-button-toggle>
			</mat-button-toggle-group>
		</div>

		<div>
			<a class="permanent-link" (click)="copyDownloadLink($event)">
				<mat-icon>link</mat-icon>
				<span>Copy download link to clipboard</span>
			</a>
		</div>

		<div class="actions">
			<button mat-raised-button color="primary" (click)="download()">
				<mat-icon>download</mat-icon>
				Download
			</button>
		</div>
	</div>
</mat-dialog-content>
